<template>
  <v-snackbar bottom right v-model="snackbar" :timeout="timeout">
    <div>{{ text }}</div>
  </v-snackbar>
</template>

<script>
export default {
  data() {
    return {
      timeout: 2000,
      text: '',
      snackbar: false,
    }
  },
  methods: {
    open(text) {
      this.text = text
      this.snackbar = true
    },
  },
}
</script>

<style lang="less" scoped>
div {
  text-align: center;
}
</style>
